import { Subject } from '../../models/common-data';
import { SPECIAL_ADMISSIONS_DEFAULT_NAME, EXAM_SUBJECT_DISPLAY_NAMES } from '../../resources/common-id/exam-subject-display-names';
import { EXCLUDE_YEARS } from '../../resources/common-id-config';
import { SubjectId } from '../../resources/config';

export class CommonIdSubjectUtil {
  static getSubjectName(paperId: string, subjects: Subject[]): string {
    // 教科名がリストにある場合はリストより教科名を取得
    const subjectName = EXAM_SUBJECT_DISPLAY_NAMES[paperId];
    if (subjectName) return subjectName;

    const subjectId = paperId.substring(6, 8);

    // 推薦・総合（50）の場合はデフォルト科目名を取得
    if (subjectId === SubjectId.SPECIAL_ADMISSIONS) return SPECIAL_ADMISSIONS_DEFAULT_NAME;

    // 教科名がリストにない場合は通常の教科名を設定
    const subject = subjects.find(obj => obj.id === subjectId);
    if (subject) return subject.name;

    return subjectId;
  }

  static isExcludeYear(subjectId: string, year: string): boolean {
    const targetYear = year.length === 2 ? parseInt(`20${year}`, 10) : parseInt(year, 10);
    const excludeYearsBySubjectId = EXCLUDE_YEARS.filter(excludeYear => excludeYear.subjectId === subjectId);
    if (excludeYearsBySubjectId.length > 0 && targetYear <= excludeYearsBySubjectId[0].year) {
      return true;
    }
    return false;
  }
}
